import React from 'react';
import { useNavigate } from 'react-router-dom';
import { featuredStore } from '../mock';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { BrandMono, TickList, ContactPromptCard } from './SharedUI';

export default function StoreSection() {
  const navigate = useNavigate();

  return (
    <section id="store" className="section">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginBottom: 56,
          gap: 24,
          flexWrap: 'wrap',
        }}
        className="reveal"
      >
        <div>
          <div className="section-label" style={{ marginBottom: 16 }}>
            05 &mdash; Store
          </div>
          <h2 className="section-title" style={{ margin: 0, maxWidth: 760 }}>
            Premium tools,<br />
            <span style={{ color: 'rgba(245,245,245,0.45)' }}>half the price.</span>
          </h2>
        </div>
        <p
          style={{
            color: 'rgba(245,245,245,0.55)',
            maxWidth: 420,
            fontSize: 15,
            lineHeight: 1.7,
          }}
        >
          Genuine access to the apps creators actually use &mdash; delivered fast,
          at around 50% of retail. Tap any product to request it.
        </p>
      </div>

      <div
        className="store-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gap: 20,
        }}
      >
        {featuredStore.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}

        {/* fill 6th slot already; add See-more on the next row to balance */}
      </div>

      <div style={{ marginTop: 24 }}>
        <div
          onClick={() => navigate('/store')}
          className="see-more-card reveal"
          style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'left', padding: '24px 28px' }}
        >
          <div>
            <div
              className="mono"
              style={{
                fontSize: 10,
                letterSpacing: '0.35em',
                color: 'rgba(245,245,245,0.5)',
                textTransform: 'uppercase',
              }}
            >
              / Full catalogue
            </div>
            <div
              style={{
                marginTop: 6,
                fontFamily: 'Space Grotesk, sans-serif',
                fontSize: 22,
                color: '#f5f5f5',
              }}
            >
              See more products
            </div>
            <div style={{ marginTop: 4, color: 'rgba(245,245,245,0.55)', fontSize: 13 }}>
              Netflix, Adobe, ChatGPT, gaming, the unlimited-pack &amp; more.
            </div>
          </div>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '12px 22px',
              borderRadius: 999,
              background: '#f5f5f5',
              color: '#000',
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 11,
              letterSpacing: '0.28em',
              textTransform: 'uppercase',
              flexShrink: 0,
            }}
          >
            Open store <ArrowRight size={14} />
          </span>
        </div>
      </div>

      <ContactPromptCard message="Looking for something not listed? Drop me a message — I probably have it." />
    </section>
  );
}

export function ProductCard({ product }) {
  const goContact = () => {
    const el = document.getElementById('contact');
    if (el) window.scrollTo({ top: el.offsetTop - 40, behavior: 'smooth' });
  };
  return (
    <div
      className="glass-card reveal"
      style={{ padding: 28, display: 'flex', flexDirection: 'column', gap: 18 }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <BrandMono letter={product.letter} size={48} />
        <ShoppingBag size={16} strokeWidth={1.5} color="rgba(245,245,245,0.55)" />
      </div>
      <h3
        style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontWeight: 500,
          fontSize: 22,
          margin: 0,
          letterSpacing: '-0.01em',
        }}
      >
        {product.name}
      </h3>
      <TickList items={product.perks} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginTop: 'auto',
          paddingTop: 16,
          borderTop: '1px solid rgba(245,245,245,0.06)',
        }}
      >
        <button
          className="btn-ghost"
          style={{ padding: '8px 16px', fontSize: 10 }}
          onClick={goContact}
        >
          Request
        </button>
      </div>
    </div>
  );
}
